import React, { useContext } from 'react';
import { Button, Card, Col, Row } from 'antd';
import './CardView.css';

import {isFMPCreatorOrAdministrator, isIPSAdministrator} from '../../utils/UserInfo';

import {
  getToolTipFormatedList,
  getToolTipFormatedStrForIPSDT,
} from '../Utils/String';
import IpsDTCommentsIcon from 'components/CommentsIcon/IpsDTCommentsIcon';

import SeverityIcon from 'components/SeverityIcon/SeverityIcon';
import { tabNamesMap } from 'components/TabNamesMap';
import PhasedProjectComponent from './PhasedProjectComponent';

export default function IpsFMPDataCardView(props) {
  const {
    project,
    onButtonClick,
    history,
    context,
    loading,
    handleDeleteBtnClick,
  } = props;


  // for getting color of status
  const getStatusColor = {
    G: '#55b762',
    // Y: '#d2b16f',
    Y: '#e1ad01',
    R: '#d24448',
  };

  const getProjectHeaderColor = {
    // FMP_G: '#bf9000',// old color
    FMP_C: '#D97623',
    FMP_P: '#ffc300',
    FMP_R: '#2691DE',
    FMP_B: '#54009E',
    FMP_A: '#009e0f',
    FMP_G: '#61B82A'
  };

  let getFMPLinkName = {
    FMP_P: 'Start FMP Tracker',
    FMP_C: 'Go To FMP Tracker',
    FMP_R: 'Go To FMP Tracker',
    FMP_B: 'Go To FMP Tracker',
    FMP_A: 'Go To FMP Tracker',
    FMP_G: 'Go To FMP Tracker'
  };

  function getActionsForStatus() {
    let actions = [];

    if (project.trackerStatus === 'FMP_C' || project.trackerStatus === 'FMP_A' || project.trackerStatus === 'FMP_G' || project.trackerStatus === 'FMP_B' || project.trackerStatus === 'FMP_R') {
      actions.push(
        <>
          {isIPSAdministrator() && (
            <Button
              id={'inDevCardEditLink'}
              className='dt-delete-btn'
              type={'link'}
              style={{ height: 'auto' }}
              onClick={() => handleDeleteBtnClick(project)}
            >
              Delete
            </Button>
          )}
          <Button
            id={'inDevCardEditLink'}
            type={'link'}
            style={{ height: 'auto' }}
            onClick={() => onButtonClick(project)}
          >
            {getFMPLinkName[project.trackerStatus]}
          </Button>
        </>
      );
      // https://jira.aepsc.com/browse/TCHEK-629
    } else if (
      project.trackerStatus === 'FMP_P'

    ) {
      actions.push(
        !isFMPCreatorOrAdministrator() ? (
          <Button
            id={'inDevCardEditLink'}
            type={'link'}
            style={{ height: 'auto', color: 'black' }}
            disabled={true}
          >
            Contact a Admin
          </Button>
        ) : (
          <Button
            id={'inDevCardEditLink'}
            type={'link'}
            style={{ height: 'auto' }}
            onClick={() => onButtonClick(project)}
          >
            {getFMPLinkName[project.trackerStatus]}
          </Button>
        )
      );
    } else if (

      project.trackerStatus === 'FMP_P'
    ) {
      actions.push(
        !isIPSAdministrator() ? (
          <Button
            id={'inDevCardEditLink'}
            type={'link'}
            style={{ height: 'auto', color: 'black' }}
            disabled={true}
          >
            Contact a Admin
          </Button>
        ) : (
          <Button
            id={'inDevCardEditLink'}
            type={'link'}
            style={{ height: 'auto' }}
            onClick={() => onButtonClick(project)}
          >
            {getFMPLinkName[project.trackerStatus]}
          </Button>
        )
      );
    }

    return actions;
  }

  function getCardTypeHeader() {
    let commonDesign = {
      minWidth: '120px',
      height: '70px',
      padding: '4px',
      fontSize: '16px',
      textAlign: 'center',
      color: '#fff',
    };


    return {
      backgroundColor: getProjectHeaderColor[project.trackerStatus],
      ...commonDesign,
    };
  }

  return (
    <Card
      title={
        <span style={{ color: project.trackerStatus === 'FMP_R' ? 'white' : 'white' }}>
          {project?.id?.stationName ? project?.id?.stationName : ' '}
          <br />{' '}
        </span>
      }
      id={'cardId' + project?.id?.bpid + project?.id?.stationName + project?.id?.workOrder}
      actions={getActionsForStatus()}
      headStyle={getCardTypeHeader()}
      bodyStyle={{
        fontSize: '12px',
        backgroundColor: '#ffffff',

        // maxHeight: project.trackerStatus !== 'FMP_P' ? '31.5rem' : '25.5rem',
        // minHeight: project.trackerStatus !== 'FMP_P' ? '31.5rem' : '25.5rem',
        maxHeight: '31.5rem',
        minHeight: '31.5rem',
      }}
      style={{ marginBottom: '16px', boxShadow: '5px 5px 5px lightgrey' }}
      loading={loading}
    >
      <div>
        <b>Project Description</b>
        {project.trackerStatus !== 'FMP_P' && (
          <IpsDTCommentsIcon
            project={project}
            commentGroup={'COMMON'}
            view={'dashboard'}
            comments={[]}
            phase={0}
          />
        )}
        {project.severity && project.severity >= 2 ? <SeverityIcon project={project} /> : <></>}
        <br />
        <div>
          {project.projectDescription &&
            getToolTipFormatedList(project.projectDescription)}
        </div>
        {/* <br /> */}
        <hr />
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className='section-container'>
              <div className='ids-section-container'>
                <b>WO:</b>
              </div>
              <span>
                {getToolTipFormatedStrForIPSDT('WO', project?.id?.workOrder, project)}
              </span>
            </div>
            <div className='section-container'>
              <div className='ids-section-container'>
                <b>BPID:</b>
              </div>
              <span>
                {getToolTipFormatedStrForIPSDT('BPID', project?.id?.bpid, project)}
              </span>
            </div>
            <div className='section-container'>
              <div className='ids-section-container'>
                <b>MPID:</b>
              </div>
              <span>
                {getToolTipFormatedStrForIPSDT('MPID', project.mpid, project)}
              </span>
            </div>
          </Col>
          <Col xs={21} sm={12} md={12} lg={12} xl={12}>
            <div className='section-container'>
              <div className='ids-section-container-right'>
                <b>CCA:</b>
              </div>
              <span>
                {project.ccaNames &&
                  getToolTipFormatedStrForIPSDT('CCA', project.ccaNames, project)}
              </span>
            </div>
            <div className='section-container'>
              <div className='ids-section-container-right'>
                <b>RCA:</b>
              </div>
              <span>
                {project.rcaNames &&
                  getToolTipFormatedStrForIPSDT('RCA', project.rcaNames, project)}
              </span>
            </div>
            <div className='section-container'>
              <div className='ids-section-container-right'>
                <b>LCA:</b>
              </div>
              <span>
                {project.lcaNames &&
                  getToolTipFormatedStrForIPSDT('LCA', project.lcaNames, project)}
              </span>
            </div>
          </Col>
        </Row>
        <hr />
        <div className='section-container'>
          <div className='new-container'>
            <b>WO In-Service Date:</b>
          </div>
          <span>{project?.inServiceDate}</span>
        </div>

        <hr />

        <div className='section-container'>
          <div className='new-container'>
            <b>FMP Physical Tracks:</b>
          </div>
          <span>{project.noOfPhysicalTracks}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>FMP P&C Tracks:</b>
          </div>
          <span>{project.noOfPCETracks}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>FMP Oneline Tracks:</b>
          </div>
          <span>{project.noOfOnelineTracks}</span>
        </div>

        <hr />
        <div className='section-container'>
          <div className='new-container'>
            <b>State:</b>
          </div>
          <span>{project.stationState}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>Station Region:</b>
          </div>
          <span>{project.stationRegion}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>TFS Station Area:</b>
          </div>
          <span>{project.tfStationArea}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>TFS P&C Area:</b>
          </div>
          <span>{project.pcArea}</span>
        </div>

        <hr />

        <br />


        <div className='section-container'>
          <div className='new-container'>
            <b>Total No. of SE Assets:</b>
          </div>
          <span>{project.noOfSEAssets}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>Total No. of PCE Assets:</b>
          </div>
          <span>{project.noOfPCEAssets}</span>
        </div>
        <div className='section-container'>
          <div className='new-container'>
            <b>Total No. of Assets:</b>
          </div>
          <span>{project.noOfAssets}</span>
        </div>
      </div>
    </Card>
  );
}